<template>
  <div class="upgrade-major-manage">
    <h2>专升本专业管理</h2>
    
    <div style="margin-bottom: 20px;">
      <el-button type="primary" @click="showAddDialog">添加专业</el-button>
      <el-button 
        type="danger" 
        icon="el-icon-delete" 
        :disabled="selectedRows.length === 0"
        @click="handleBatchDelete">
        批量删除
      </el-button>
    </div>
    
    <el-table 
      :data="majorList" 
      style="width: 100%;" 
      border
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column prop="collegeName" label="学校名称" width="200"></el-table-column>
      <el-table-column prop="majorName" label="专业名称" width="200"></el-table-column>
      <el-table-column prop="receiveMajor" label="接收专业" width="200"></el-table-column>
      <el-table-column prop="enrollmentCount" label="招生人数" width="120"></el-table-column>
      <el-table-column prop="tuitionFee" label="学费（元/年）" width="150"></el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      style="margin-top: 20px; text-align: right;">
    </el-pagination>

    <!-- 添加/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form :model="form" label-width="120px">
        <el-form-item label="学校名称">
          <el-select v-model="form.collegeId" placeholder="请选择学校" @change="handleCollegeChange" style="width: 100%">
            <el-option
              v-for="college in collegeList"
              :key="college.id"
              :label="college.collegeName"
              :value="college.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业名称">
          <el-input v-model="form.majorName" placeholder="请输入专业名称"></el-input>
        </el-form-item>
        <el-form-item label="接收专业">
          <el-input v-model="form.receiveMajor" placeholder="请输入接收专业（对应的专科专业）"></el-input>
        </el-form-item>
        <el-form-item label="招生人数">
          <el-input-number v-model="form.enrollmentCount" :min="0" placeholder="请输入招生人数"></el-input-number>
        </el-form-item>
        <el-form-item label="学费（元/年）">
          <el-input-number v-model="form.tuitionFee" :min="0" :precision="2" placeholder="请输入学费"></el-input-number>
        </el-form-item>
        <el-form-item label="考试科目">
          <el-input v-model="form.examSubjects" type="textarea" :rows="3" placeholder="请输入考试科目"></el-input>
        </el-form-item>
        <el-form-item label="招生计划">
          <el-input v-model="form.enrollmentPlan" type="textarea" :rows="3" placeholder="请输入招生计划"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import upgradeMajorApi from '@/api/upgradeMajor'
import collegeApi from '@/api/college'

export default {
  name: 'UpgradeMajorManage',
  data() {
    return {
      majorList: [],
      collegeList: [],
      dialogVisible: false,
      dialogTitle: '添加专业',
      isEdit: false,
      form: {
        id: null,
        collegeId: null,
        collegeName: '',
        majorName: '',
        receiveMajor: '',
        enrollmentCount: null,
        tuitionFee: null,
        examSubjects: '',
        enrollmentPlan: ''
      },
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0,
      pageSizes: [5, 10, 20, 50],
      // 批量删除相关
      selectedRows: []
    }
  },
  mounted() {
    this.loadMajorList()
    this.loadCollegeList()
  },
  methods: {
    loadMajorList() {
      upgradeMajorApi.getList(this.currentPage, this.pageSize).then(res => {
        if (res.data.code === 200) {
          this.majorList = res.data.data
          this.total = res.data.total || 0
        }
      })
    },
    loadCollegeList() {
      // 获取所有学校，设置一个足够大的size
      collegeApi.getList(1, 1000).then(res => {
        if (res.data.code === 200) {
          this.collegeList = res.data.data
        }
      })
    },
    handleCollegeChange(collegeId) {
      const college = this.collegeList.find(c => c.id === collegeId)
      if (college) {
        this.form.collegeName = college.collegeName
      }
    },
    showAddDialog() {
      this.dialogTitle = '添加专业'
      this.isEdit = false
      this.form = {
        id: null,
        collegeId: null,
        collegeName: '',
        majorName: '',
        receiveMajor: '',
        enrollmentCount: null,
        tuitionFee: null,
        examSubjects: '',
        enrollmentPlan: ''
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑专业'
      this.isEdit = true
      this.form = { ...row }
      this.dialogVisible = true
    },
    handleSubmit() {
      const api = this.isEdit ? upgradeMajorApi.update : upgradeMajorApi.add
      api(this.form).then(res => {
        if (res.data.code === 200) {
          this.$message.success(res.data.message)
          this.dialogVisible = false
          this.loadMajorList()
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除该专业吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        upgradeMajorApi.delete(id).then(res => {
          if (res.data.code === 200) {
            this.$message.success(res.data.message)
            this.loadMajorList()
          } else {
            this.$message.error(res.data.message)
          }
        })
      })
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      
      this.$confirm(`确定删除选中的 ${this.selectedRows.length} 条数据吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const ids = this.selectedRows.map(row => row.id)
        upgradeMajorApi.batchDelete(ids).then(res => {
          if (res.data.code === 200) {
            this.$message.success(res.data.message)
            this.loadMajorList()
          } else {
            this.$message.error(res.data.message)
          }
        })
      })
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadMajorList()
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.loadMajorList()
    }
  }
}
</script>

<style scoped>
.upgrade-major-manage {
  padding: 20px;
}
</style>
